import { createIcon } from './createIcon'

export const DraggableIcon = createIcon({
  displayName: 'DraggableIcon',
  viewBox: '0 0 10 17',
  path: [
    <circle cx="1.73913" cy="2.05529" r="1.73913" fill="currentColor" />,
    <circle cx="1.73913" cy="8.31616" r="1.73913" fill="currentColor" />,
    <circle cx="1.73913" cy="14.577" r="1.73913" fill="currentColor" />,
    <circle cx="8.00012" cy="2.05529" r="1.73913" fill="currentColor" />,
    <circle cx="8.00012" cy="8.31616" r="1.73913" fill="currentColor" />,
    <circle cx="8.00012" cy="14.577" r="1.73913" fill="currentColor" />,
  ],
})
